import styled from '@emotion/styled';
import React from 'react';
import sizes from 'style/sizes';
import { mq } from 'style/variables';

type TopicsListWrapProps = {};

const Container = styled.div`
  margin-top: ${sizes.margin[81]};
  margin-bottom: ${sizes.margin[81]};
  ${mq.onlysp} {
    margin-top: 108px;
    margin-bottom: 108px;
  }
`;

export const TopicsListWrap: React.FC<TopicsListWrapProps> = props => {
  return <Container>{props.children}</Container>;
};
